import type { ApiBaseResponse } from '@hotjar/webapp/domains/common/api';
import axios from 'axios';

import { CurrentPaymentMethod } from './plan';

export interface Account {
  id: number;
}

export interface PaymentMethodResponse {
  available: boolean;
  expiryDate: number;
  label: string;
  type: string;
  pastDue: boolean;
}

export const api = {
  /**
   * **WARNING!** this returns the CurrentPaymentMethod which is different from the VaultedPaymentMethod,
   * for VaultedPaymentMethod use paymentMethodAPI.get in `@hotjar/webapp/domains/billing/paymentMethod`
   */
  get: (account: Account): Promise<CurrentPaymentMethod & ApiBaseResponse> =>
    axios
      .get(`/api/v1/accounts/${account.id}/payment/details`)
      .then((response) =>
        response.data.success
          ? CurrentPaymentMethod.fromResponse(response.data)
          : Promise.reject(response.data.error),
      ),
};
